
import { useState } from 'react';

const GOOGLE_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSfSC_rDrzoMTCBvQw742eBCCfYPicBhJNj_fVhygl4nGHPAOg/formResponse';
const EMAIL_ENTRY_ID = 'entry.1914212869';
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface UnavailableAcquirerNoticeProps {
  acquirerName: string;
  onCancel: () => void;
}

export default function UnavailableAcquirerNotice({
  acquirerName,
  onCancel,
}: UnavailableAcquirerNoticeProps) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [emailError, setEmailError] = useState('');

  const handleNotify = async () => {
    if (!email || !EMAIL_REGEX.test(email.trim())) {
      setEmailError('Ingresa un correo electrónico válido.');
      return;
    }
    setSubmitting(true);
    setEmailError('');
    try {
      const formData = new URLSearchParams();
      formData.append(EMAIL_ENTRY_ID, email.trim());
      await fetch(GOOGLE_FORM_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitting(false);
      setSubmitted(true);
    } catch {
      setSubmitting(false);
      setEmailError('Error al enviar. Intenta de nuevo.');
    }
  };

  return (
    <div className="rounded-lg bg-sky-50 dark:bg-sky-900/20 border border-sky-100 dark:border-sky-800/50 p-5">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-shrink-0 pt-0.5">
          <div className="h-10 w-10 bg-sky-100 dark:bg-sky-800/40 rounded-full flex items-center justify-center text-sky-600 dark:text-sky-300">
            <span className="material-symbols-outlined">notifications_active</span>
          </div>
        </div>

        <div className="flex-1 space-y-4">
          <div>
            <h4 className="text-base font-semibold text-sky-900 dark:text-sky-100">
              Próximamente disponible
            </h4>
            <p className="mt-1 text-sm text-sky-800 dark:text-sky-200/80 leading-relaxed">
              {submitted
                ? `¡Listo! Te notificaremos cuando ${acquirerName} esté disponible en la plataforma FLUX.`
                : `Este adquirente aún no se encuentra habilitado en la plataforma FLUX. Ingresa tu correo electrónico para notificarte el día en que lo habilitemos.`}
            </p>
          </div>

          {!submitted && (
            <div className="w-full max-w-md">
              <label
                htmlFor="notify-email"
                className="block text-sm font-medium text-sky-900 dark:text-sky-100 mb-1.5"
              >
                Correo electrónico
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="material-symbols-outlined text-sky-500 dark:text-sky-400 text-lg">
                    mail
                  </span>
                </div>
                <input
                  id="notify-email"
                  name="notify_email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (emailError) setEmailError('');
                  }}
                  placeholder="tu@empresa.com"
                  className={`block w-full pl-10 pr-3 py-2.5 border rounded-lg bg-white dark:bg-slate-900 text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:border-transparent text-sm ${
                    emailError
                      ? 'border-red-400 dark:border-red-500 focus:ring-red-500'
                      : 'border-sky-200 dark:border-sky-700 focus:ring-sky-500'
                  }`}
                />
              </div>
              {emailError && (
                <p className="text-xs text-red-500 mt-1">{emailError}</p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center justify-end gap-3 pt-4 mt-4 border-t border-sky-200/60 dark:border-sky-800/40">
        <button
          onClick={onCancel}
          type="button"
          className="px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-white dark:hover:bg-slate-700 rounded-lg border border-transparent hover:border-slate-300 dark:hover:border-slate-600 transition-all"
        >
          Cancelar
        </button>
        {!submitted ? (
          <button
            onClick={handleNotify}
            disabled={!email || submitting}
            type="button"
            className="inline-flex items-center justify-center px-6 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-primary hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {submitting ? 'Enviando...' : 'Notificarme'}
          </button>
        ) : (
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-emerald-600 dark:text-emerald-400">
            <span className="material-symbols-outlined text-base">check_circle</span>
            Registrado
          </span>
        )}
      </div>
    </div>
  );
}
